import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import initializeAuthentication from "../Firebase/firebase.init";

initializeAuthentication();

const useFirebase = () => {
  const [user, setUser] = useState();
  const [error, setError] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const history = useHistory();

  const auth = getAuth();

  const googleProvider = new GoogleAuthProvider();
  // Google Login Method

  const googleLogin = () => {
    return signInWithPopup(auth, googleProvider);
  };
  // capture the input filed value from login/registration form
  const toggleLogin = (e) => {
    setIsLogin(e.target.checked);
  };

  const handleUserName = (e) => {
    setName(e.target.value);
  };
  const handleUserEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleUserPassword = (e) => {
    setPassword(e.target.value);
  };

  // user registration process

  const handleRegistration = (e) => {
    e.preventDefault();
    console.log(email, password);
    if (password.length < 6) {
      setError("Password Must be at least 6 characters long.");
      return;
    }
    if (!/(?=.*[A-Z].*[A-Z])/.test(password)) {
      setError("Password Must contain 2 upper case");
      return;
    }

    if (isLogin) {
      userLogin(email, password);
    } else {
      registerNewUser(email, password);
    }
  };
  // user Login Using email and password
  const userLogin = (email, password) => {
    console.log({ email, password });
    if (isLogin) {
      setError("Logged In SuccesFully! Refresh The Page");
    }
    return signInWithEmailAndPassword(auth, email, password);
  };
  //  New user registration method
  const registerNewUser = (email, password) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        const user = result.user;

        setError("User Added Successfully ! Refresh the page for auto login");

        setUserName();
      })
      .catch((error) => {
        setError(error.message);
      });
  };
  // Set User name
  const setUserName = () => {
    updateProfile(auth.currentUser, { displayName: name }).then((result) => {});
  };

  //    logout
  const logOut = () => {
    signOut(auth)
      .then(() => {
        setUser({});
      })
      .catch((error) => {
        setError(error.message);
      });
  };
  // observing user  auth state change or not
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser({});
      }
    });
  }, []);

  return {
    user,
    error,
    googleLogin,
    logOut,
    handleRegistration,
    handleUserName,
    handleUserEmail,
    handleUserPassword,
    userLogin,
    registerNewUser,
    toggleLogin,
    isLogin,
  };
};

export default useFirebase;
